import store from '@/store';
import S_wasaBase from '@/__vue2stone/service/wasaapi/v1/__base';
export default {
  // 舊的，前面的帶factory
  async index({
    preUrl,
    url,
    parentName,
    parentId,
    modelName,
    params,
    pagination,
  }) {
    let _params = { ...params };
    if (!_params.factory) {
      _params.factory = store.state.app.factoryId;
    }
    if (!_params.organization) {
      _params.organization = store.state.app.organizationId;
    }
    return S_wasaBase.index({
      preUrl,
      url,
      parentName,
      parentId,
      modelName,
      params: _params,
      pagination: pagination,
    });
  },
  async show({ url, modelId, params, modelName }) {
    let _params = { ...params };
    if (!_params.factory) {
      _params.factory = store.state.app.factoryId;
    }
    if (!_params.organization) {
      _params.organization = store.state.app.organizationId;
    }
    const res = await S_wasaBase.show({
      url,
      modelName,
      modelId,
      params: _params,
    });
    return res;
  },
  async update({ url, modelId, data, modelName }) {
    const _data = {
      ...data,
      factory: store.state.app.factoryId,
      organization: store.state.app.organizationId,
    };
    const res = await S_wasaBase.update({
      url,
      modelName,
      modelId,
      data: _data,
    });
    return res;
  },
  async create({ url, parentName, parentId, modelName, data }) {
    const _data = {
      ...data,
      factory: store.state.app.factoryId,
      organization: store.state.app.organizationId,
    };
    const res = await S_wasaBase.create({
      url,
      parentName,
      parentId,
      modelName,
      data: _data,
    });
    return res;
  },
  async delete({ url, modelName, modelId, params }) {
    const _params = {
      ...params,
      factory: store.state.app.factoryId,
      organization: store.state.app.organizationId,
    };
    const res = await S_wasaBase.delete({
      url,
      modelName,
      modelId,
      params: _params,
    });
    return res;
  },
};
